import React, { ReactElement, useState } from "react";
import { Dialog, Button, Snackbar } from "@material-ui/core";
import Link from "@material-ui/icons/Link";
import Alert from "@material-ui/lab/Alert";
import { useSelector, useDispatch } from "react-redux";
import { getFocusedGif, getGif } from "../../state/selectors";
import { focusGif } from "../../state/actions";

interface Props {}

export default function FocusItem({}: Props): ReactElement | null {
  const dispatch = useDispatch();
  const focusedGifId = useSelector(getFocusedGif());
  const gif = useSelector(getGif(focusedGifId));
  const [isSuccessfulCopy, setSuccessfulCopy] = useState<boolean | null>(null);
  const handleClose = () => {
    dispatch(focusGif(null));
    setSuccessfulCopy(null);
  };

  function copyLink() {
    navigator.clipboard.writeText(gif.originalUrl).then(
      () => {
        setSuccessfulCopy(true);
      },
      () => {
        setSuccessfulCopy(false);
      }
    );
  }

  function handleSuccessClose() {
    setSuccessfulCopy(null);
  }

  if (!gif) {
    return null;
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="selected-gif-modal"
      open={!!gif}
      className="flex flex-col"
    >
      <>
        <img
          src={gif.previewUrl}
          alt={gif.title}
          className="min-h-0 flex-grow object-cover"
          style={{ minWidth: "400px" }}
        ></img>
        <div className="flex flex-shrink-0">
          <Button
            className="ml-auto w-full p-4"
            variant="text"
            color="default"
            onClick={() => copyLink()}
            startIcon={<Link />}
          >
            Copy Link
          </Button>
          <Snackbar
            open={isSuccessfulCopy != null}
            autoHideDuration={6000}
            onClose={handleSuccessClose}
          >
            <Alert onClose={handleClose} severity="success">
              {isSuccessfulCopy
                ? "Link copied to your clipboard."
                : `Unable to copy to your clipboard.`}
            </Alert>
          </Snackbar>
        </div>
      </>
    </Dialog>
  );
}
